import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Mixpanel from "mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";

import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import leftarroicn from "../../assets/images/leftarroicn.svg";
import Button from "../form-components/Button";
import Input from "../form-components/Input";
import { uploadDocumentData } from "../../features/user-document/uploadDocumentSlice";
import { OK } from "../../constants/statusCode";
// import { showSuccess } from "../../utils/messageHelper";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { getSingleDocument } from "../../features/user-document/getDocumentSlice";
import { updateDocument } from "../../features/user-document/updateDocumentSlice";
import Loader from "../../common/loader/Loader";

const CreateEditorDocumentModal = ({
  setSubCategories = () => {},
  editUUID = "",
  searchValue = "",
  setEditUUID = () => {},
  perPage = 10,
  currentPage = 1,
  fromFilePreview = false,
  previousSubCategories,
}) => {
  const {
    isLoading,
    isLoadingEditData,
    // editData = null,
  } = useSelector((state) => ({
    isLoading: state?.uploadDocumentReducer?.isLoading,
    isLoadingEditData: state?.getSingleDocument?.isLoading,
    editData: state.getSingleDocument?.responseData,
  }));

  const [title, setTitle] = useState("");
  const [editorData, setEditorData] = useState("");
  const [titleErrorText, setTitleErrorText] = useState("");
  const [editorErrorText, setEditorErrorText] = useState("");
  let projectData = JSON.parse(localStorage.getItem("_user"));
  const dispatch = useDispatch();

  useEffect(() => {
    if (editUUID) {
      dispatch(getSingleDocument({ id: editUUID, docType: "text" })).then(
        (data) => {
          setTitle(data?.payload?.data?.document?.title);
          setEditorData(data?.payload?.data?.document?.description);
        }
      );
    }
  }, []);

  /* console.log(title) */
  const createNewDoc = async () => {
    if (editUUID) {
      let EditformData = {};
      EditformData.type = "text";
      EditformData.title = title;
      EditformData.description = editorData;
      EditformData.project_uuid = projectData?.projects[0]?.uuid;
      if (editorData.length > 0 && title.length > 0) {
        Mixpanel.track("Edit document button clicked", {
          Page: "Edit document page",
        });
        const { payload } = await dispatch(
          updateDocument({ id: editUUID, documentData: EditformData })
        );
        if (payload.status === OK) {
          // showSuccess("Document edit successfully!");
          dispatch(
            getDocuments({
              perPage: perPage,
              page: currentPage,
              search: searchValue,
              project_uuid: projectData?.projects[0]?.uuid,
            })
          );
          console.log(
            previousSubCategories,
            "previousSubCategories",
            fromFilePreview
          );
          if (fromFilePreview) {
            setSubCategories(previousSubCategories);
          } else {
            setSubCategories("Documents");
          }
          setEditUUID("");
        }
      } else {
        if (editorData.length <= 0) {
          setEditorErrorText("Please enter some description");
        }
        if (title.length <= 0) {
          setTitleErrorText("Please enter title");
        }
      }
    } else {
      let formData = {};
      formData.type = "text";
      formData.title = title;
      formData.description = editorData;
      formData.project_uuid = projectData?.projects[0]?.uuid;
      if (editorData.length > 0 && title.length > 0) {
        Mixpanel.track("Create document button clicked", {
          Page: "Create document page",
        });
        const { payload } = await dispatch(uploadDocumentData(formData));
        if (payload.status === OK) {
          // showSuccess(payload.data.message);
          dispatch(
            getDocuments({
              perPage: perPage,
              page: currentPage,
              search: searchValue,
              project_uuid: projectData?.projects[0]?.uuid,
            })
          );
          setSubCategories("Documents");
        }
      } else {
        if (editorData.length <= 0) {
          setEditorErrorText("Please enter some description");
        }
        if (title.length <= 0) {
          setTitleErrorText("Please enter title");
        }
      }
    }
  };

  return (
    <>
      {isLoading || isLoadingEditData ? (
        <Loader />
      ) : (
        <div className="content-right-box">
          <div className="intro-table-search container-fluid">
            <div className="row align-items-center py-3">
              <div className="col-12 col-md-6 col-xl-6">
                <h5 className="intro-title d-flex align-items-center">
                  <img
                    className="intro-icn me-2 cursor-pointer"
                    src={leftarroicn}
                    alt="leftarroicn"
                    onClick={() => {
                      setSubCategories("Documents");
                      setEditUUID("");
                      dispatch(
                        getDocuments({
                          perPage: perPage,
                          page: currentPage,
                          search: searchValue,
                          project_uuid: projectData?.projects[0]?.uuid,
                        })
                      );
                    }}
                  />
                  {editUUID ? "Edit doc" : "New doc"}
                </h5>
              </div>
              <div className="col-12 col-md-6 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
                <div className="">
                  <Button
                    type="button"
                    disabled={isLoading || isLoadingEditData}
                    className="btn btn-primary-md"
                    onClick={() => createNewDoc()}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
            <div className="newdoc-form">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="New Doc"
                  value={title}
                  autoFocus
                  onChange={(e) => {
                    setTitle(e.target.value);
                    setTitleErrorText("");
                  }}
                />
                <p className="text-start text-danger mb-2 mt-2">
                  {titleErrorText && titleErrorText}
                </p>
              </div>
              {/* <CKEditor
            editor={ClassicEditor}
            data="<p>Hello from CKEditor 5!</p>"
            config={{
              toolbar: ['heading', '|', 'bold', 'italic', 'underline', 'link', 'insertTable', '|', 'undo', 'redo'],
            }}
            onReady={editor => {
              // You can store the "editor" and use when it is needed.
              console.log('Editor is ready to use!', editor);
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              console.log({ event, editor, data });
            }}
            onBlur={(event, editor) => {
              console.log('Blur.', editor);
            }}
            onFocus={(event, editor) => {
              console.log('Focus.', editor);
            }}
          /> */}
              <div className="cike-etior-main">
                <CKEditor
                  onReady={(editor) => {
                    // console.log('Editor is ready to use!', editor);
                    // Insert the toolbar before the editable area.
                    editor.ui
                      .getEditableElement()
                      .parentElement.insertBefore(
                        editor.ui.view.toolbar.element,
                        editor.ui.getEditableElement()
                      );
                    // this.editor = editor;
                  }}
                  onError={(error, { willEditorRestart }) => {
                    // If the editor is restarted, the toolbar element will be created once again.
                    // The `onReady` callback will be called again and the new toolbar will be added.
                    // This is why you need to remove the older toolbar.
                    if (willEditorRestart) {
                      this.editor.ui.view.toolbar.element.remove();
                    }
                  }}
                  onChange={(event, editor) => {
                    setEditorData(editor.data.get());
                    setEditorErrorText("");
                  }}
                  editor={DecoupledEditor}
                  data={editorData}
                  config={{
                    toolbar: [
                      "undo",
                      "redo",
                      "|",
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "link",
                      "insertTable",
                    ],
                  }}
                />
              </div>
              <p className="text-start text-danger mb-2 mt-2">
                {editorErrorText && editorErrorText}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateEditorDocumentModal;
